import { ApplicationConfig } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideHttpClient } from "@angular/common/http";
import { routes } from "../../app.routes";
import { createEnvironmentConfigProvider } from "./environment-config.provider";
import { environment } from "../../../environments/environment";
import { AuthService } from "../services/auth.service";
import { MockAuthService } from "../services/mock-auth.service";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from "@angular/material/snack-bar";

// FusionAuth configuration
import { provideOAuthClient } from "angular-oauth2-oidc";
import { authConfig as oauthConfiguration } from "./auth.config";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(),
    // Chat environment configuration
    createEnvironmentConfigProvider(),
    // Default snackbar position
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { horizontalPosition: 'end', verticalPosition: 'top' } },
    // Conditional Auth configuration
    ...(environment.mockAuth 
      ? [
          { provide: AuthService, useClass: MockAuthService }
        ]
      : [
          provideOAuthClient(),
          { provide: "AuthConfig", useValue: oauthConfiguration }
        ]
    ),
  ],
};